import { Menu, Spin, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import ActionHeader from '../../components/Common/ActionHeader';
import DeleteWarningModal from '../../components/Common/DeleteWarningModal';
import ReadDataTable from '../../components/Common/ReadDataTable';
import { getCourseOffers } from '../../services/courseOfferService';
import { getCourses } from '../../services/courseService';
import { getPromoCodeById, getUSDValue } from '../../services/promoCodeService';
import PromoCodeEdit from './components/PromoCodes/PromoCodeEdit';
import PromoTransactions from './components/PromoTransactions/PromoTransactions';

const { Title } = Typography;
const COURSE_LIMIT = 1000;

const PromoCodeDetailPage = (props) => {
  const [promoCode, setPromoCode] = useState({});
  const [formattedData, setFormattedData] = useState({});
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [courseOffers, setCourseOffers] = useState([]);
  const [fetchingSearchData, setFetchingSearchData] = useState(false);
  const [status, setStatus] = useState({
    error: false,
    message: '',
  });

  const [referralCodeEditStatus, setReferralCodeEditStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode',
  });

  const dateFormat = 'dddd, Do MMMM YYYY h:mm:ssA Z';

  const getFormatData = (data) => {
    let amount = `${data.discountValue} %`;
    if(data.discountType === "amount_off"){
      let currency = data.currency ? data.currency : "USD";
      amount = `${data.discountValue}  ${currency}`;
    }
    let formData = {
      general: [
        {
          label: 'Code:',
          text: data.code ? data.code : '',
          key: 'code',
        },
        {
          label: 'Type:',
          text: data.type ? data.type : '',
          key: 'type',
        },
        {
          label: 'Value: ',
          text: amount,
          key: 'value',
        },
        {
          label: 'Referrer/Gifted by: ',
          text:
            data.type === 'referral'
              ? data.metadata?.referrer?.email
              : data.metadata?.giftedBy?.email,
          key: 'referrer',
        },
        {
          label: 'Assigned to ',
          text: data.metadata?.assignedTo
            ? data.metadata?.assignedTo?.email
            : '',
          key: 'assignedTo',
        },
        {
          label: 'Active: ',
          text: data.isActive ? "Yes" : "No",
          key: 'isActive',
        },
        {
          label: 'Courses Applicable: ',
          text: data.coursesAllowed ? data.coursesAllowed.map((course)=> {return course + ", "}) : "",
          key: 'coursesAllowed',
        },
        {
          label: 'Courses Offers Applicable: ',
          text: data.courseOffersAllowed ? data.courseOffersAllowed.map((offer)=> {return offer + ", "}) : "",
          key: 'courseOffersAllowed',
        },
        {
          label: 'Allowed In All Countries: ',
          text: data.allowInAllCountries ? "Yes" : "No",
          key: 'allowInAllCountries',
        },
        {
          label: 'Revenue Split Type: ',
          text: data.revenueSplitType ? data.revenueSplitType: "",
          key: 'revenueSplitType',
        },
        {
          label: 'Revenue Share Type: ',
          text: data.revenueSplitSubType ? data.revenueSplitSubType: "",
          key: 'revenueSplitSubType',
        },
        {
          label: 'Start Date:',
          text: data.startDate
            ? moment(data.startDate).utc().local().format(dateFormat)
            : '',
          key: 'startDate',
        },
        {
          label: 'End Date:',
          text: data.endDate
            ? moment(data.endDate).utc().local().format(dateFormat)
            : '',
          key: 'endDate',
        },
        {
          label: 'Exclude from Enrolment Count: ',
          text: data.excludeEnrolment ? "Yes" : "No",
          key: 'excludeEnrolment',
        },
        {
          label: 'Is Corporate Promo: ',
          text: data.isCorporate ? "Yes" : "No",
          key: 'isCorporate',
        },
        {
          label: 'corporatePercent: ',
          text: data.corporatePercent,
          key: 'corporatePercent',
        },
      ],
    };
    if(data.academyRevenueShareValue){
      formData.general.push({
        label: 'Nas Academy Revenue Share Value: ',
        text:
          data.academyRevenueShareValue && data.academyRevenueShareType
            ? `${data.academyRevenueShareValue} (${data.academyRevenueShareType})`
            : '',
        key: 'academyRevenueShareValue',
      })
    }
    return formData;
  };

  const actionMenu = (
    <Menu>
      <Menu.Item onClick={() => setIsEditModalVisible(true)}>Edit</Menu.Item>
      <Menu.Item onClick={() => setIsDeleteModalVisible(true)}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const getData = () => {
    setIsLoading(true);
    getPromoCodeById(1, 20, props.match.params.promoId)
      .then((response) => {
        if (response.data) {
          let promoCodeData = response.data;
          if(promoCodeData){
            promoCodeData.promo.discountValue = promoCodeData.promo.discountType === "amount_off" ? getUSDValue(promoCodeData.promo.discountValue) : promoCodeData.promo.discountValue;
            if(promoCodeData.promo.countryWiseDiscounts && promoCodeData.promo.countryWiseDiscounts.length > 0){
              promoCodeData.promo.countryWiseDiscounts.forEach(countryDiscount => {
                countryDiscount.value = promoCodeData.promo.discountType === "amount_off" ? getUSDValue(countryDiscount.value) : countryDiscount.value;
              });
            }
          }
          setPromoCode(promoCodeData?.promo);
          setTransactions(promoCodeData?.transactions);
          let data = getFormatData(promoCodeData?.promo);
          setFormattedData(data);
        } else {
          throw Error('This course offer does not exist!');
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err.message}`,
        });
        setIsLoading(false);
      });
  };

  const getTransactions = async (currentPage, limit, params) => {
    return await getPromoCodeById(
      currentPage,
      limit,
      props.match.params.promoId
    );
  };

  const fetchCourse = () => {
    setFetchingSearchData(true);
    getCourses(1, COURSE_LIMIT, {})
      .then((response) => {
        const data = response.data.paginatedList.map((course) => ({
          label: course.code,
          value: course.code,
        }));
        setCourses(data);
        setFetchingSearchData(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else
          setStatus({
            type: 'ERROR',
            message: 'Getting questions from the backend failed!',
          });
      });
  };

  const fetchCourseOffer = () => {
    setFetchingSearchData(true);
    getCourseOffers(1, COURSE_LIMIT, {})
      .then((response) => {
        const data = response.data.paginatedList.map((offer) => ({
          label: offer.code,
          value: offer.code,
        }));
        setCourseOffers(data);
        setFetchingSearchData(false);
      })
      .catch((error) => {
        if (error?.response?.data?.message)
          setStatus({ type: 'ERROR', message: error.response.data.message });
        else
          setStatus({
            type: 'ERROR',
            message: 'Getting questions from the backend failed!',
          });
      });
  };

  useEffect(() => {
    getData();
    fetchCourseOffer();
    fetchCourse();
  }, [props.match.params.promoId]);

  return (
    <div>
      {isLoading ? (
        <div
          style={{
            textAlign: 'center',
            marginTop: '50px',
          }}
        >
          <Spin />
        </div>
      ) : status.error ? (
        <div style={{ marginTop: '50px', textAlign: 'center' }}>
          <Title>{status.message}</Title>
        </div>
      ) : (
        <>
          <DeleteWarningModal
            isVisible={isDeleteModalVisible}
            setIsVisible={setIsDeleteModalVisible}
            deleteLink={`${process.env.REACT_APP_BACKEND_URL}/`}
            params={{}}
          />

          <PromoCodeEdit
            isOpen={isEditModalVisible}
            toggle={() => setIsEditModalVisible(false)}
            promoCode={promoCode}
            id={props.match.params.promoId}
            status={referralCodeEditStatus}
            setStatus={setReferralCodeEditStatus}
            courseOffers={courseOffers}
            courses={courses}
          />

          <ActionHeader
            title={`Promo Code: ${promoCode?.code}`}
            actionMenu={actionMenu}
          />

          {formattedData.general ? (
            <section className="grey-section">
              <Title level={5}>Details</Title>
              <ReadDataTable items={formattedData.general} />
            </section>
          ) : null}

          {transactions?.paginatedList &&
            transactions?.paginatedList?.length > 0 && (
              <PromoTransactions
                getTransactions={getTransactions}
                type="withCode"
              />
            )}
        </>
      )}
    </div>
  );
};

export default withRouter(PromoCodeDetailPage);
